import * as SelectPrimitive from '@radix-ui/react-select';
import clsx from 'clsx';
import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ElementRef } from 'react';

import ChevronDownIcon from 'components/icons/chevron-down';

import style from './select-compound.module.scss';

const SelectIcon = forwardRef<
  ElementRef<typeof SelectPrimitive.Icon>,
  Omit<ComponentPropsWithoutRef<typeof SelectPrimitive.Icon>, 'asChild' | 'children'>
>(({ className, ...props }, ref) => (
  <SelectPrimitive.Icon ref={ref} className={clsx(style.SelectIcon, className)} {...props}>
    <ChevronDownIcon height="10px" />
  </SelectPrimitive.Icon>
));
SelectIcon.displayName = SelectPrimitive.Icon.displayName;

export { SelectIcon };
